import React from 'react'
import { useFetchHouseConsignments } from '../../../../house-consignment/api/fetchHouseConsignments'
import TransitHouseConsignmentsTable from './TransitHouseConsignmentsTable'

interface HouseConsignmentsTabProps {
  consignmentId: number
  interactionsLocked: boolean
}

function TransitHouseConsignmentsTab({ consignmentId, interactionsLocked }: Readonly<HouseConsignmentsTabProps>) {
  const { data: houseConsignments, isFetching } = useFetchHouseConsignments(consignmentId, !interactionsLocked)

  return (
    <div className="container-fluid py-3">
      <div className="consignments-card">
        <TransitHouseConsignmentsTable
          consignmentId={consignmentId}
          houseConsignments={houseConsignments ?? []}
          loading={isFetching}
        />
      </div>
    </div>
  )
}

export default TransitHouseConsignmentsTab
